import { IconContainer } from "@src/components/helper.styled";

const PipelineHealthIcon = () => {
	return (
		<IconContainer>
			<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M1.5 9.5H5L6.5 5.5L9.5 13.5L11 9.5H16.5"
					stroke="white"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</IconContainer>
	);
};

export default PipelineHealthIcon;
